import CTASection from "../components/CTASection";
import { FEATURES } from "../data/data";
import logoImage from "../assets/images/MM-Final-Logo.webp";
import { Helmet } from "react-helmet";

export default function AboutPage({ setPage }) {
  return (
    <>
    <Helmet>
  <title>About Us | Millet Momos</title>
  <meta name="description" content="Learn about Millet Momos, our mission to provide healthy and nutritious millet-based food." />
</Helmet>
      <div className="page-banner" style={{ background: "linear-gradient(135deg,#0A0A0A 0%,#2A2A2A 100%)" }}>
        <div>
          <h1>About <span>Millet Momos</span></h1>
          <p>We believe great food should nourish you. Our story starts with ancient grains and ends on your plate.</p>
        </div>
      </div>

      <div className="mission-strip">
        <h2>Guilt Kam. Swad Full.</h2>
        <p>Our mission is simple: bring the goodness of ancient Indian millets to your favourite comfort food — momos — without compromising on taste, texture, or tradition.</p>
      </div>

      <section className="story-section">
        <div className="story-grid">
          <div className="story-text">
            <h2>Our <span>Story</span></h2>
            <p>Millet Momos was born from a simple question: why should healthy food taste boring? We grew up loving momos — the steam, the filling, the dipping sauce. But regular momos are made with maida (refined flour), which offers little nutritional value.</p>
            <p>We set out to change that. After months of testing with farmers, nutritionists, and momo lovers across Hyderabad, we perfected a recipe that uses 100% natural millets — ancient supergrains that India has grown for thousands of years.</p>
            <p>The result is a momo that's higher in fiber, protein, and micronutrients than anything made with refined flour. And it tastes <em>amazing</em>.</p>
          </div>
          <div className="story-box">
            <img src={logoImage} alt="Logo"  loading="lazy" />
            <div className="brand-tag">Since 2026</div>
            <p>Handcrafted in Hyderabad with love, care, and the finest Indian millets. No shortcuts. No maida. Just real food.</p>
          </div>
        </div>
      </section>

      {/* All 6 features */}
      <section className="features-section" style={{ background: "var(--gray)" }}>
        <div className="sec-header">
          <h2 className="sec-title">Why Choose Healthy Millet Momos?</h2>
          <p className="sec-sub">We're revolutionizing comfort food by combining traditional momos with the power of ancient supergrains</p>
        </div>
        <div className="features-grid">
          {FEATURES.map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon"><img src={f.img} alt={f.title} className="icons-millet"  loading="lazy" /></div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <CTASection setPage={setPage} />
    </>
  );
}